import { Button, Modal, Typography } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import styles from './index.module.css';

interface Props {
  isOpen: boolean;
  name: string;
  onClose: () => void;
}

export const MASKED_RESUME_NOTE =
  'The resume is hidden in the anonymised view. Scores, skills and the career path on this page come from it; the document itself is not shown to this account.';

/**
 * What "View resume" opens for an anonymised candidate (`Candidate.masked`):
 * a frosted, document-shaped stand-in and a plain sentence saying why. The
 * server refuses the real file for this viewer (403), so nothing is fetched;
 * this keeps the button and shows the product has a resume behind the match,
 * without pretending the page is the file.
 */
const MaskedResumeModal = ({ isOpen, name, onClose }: Props) => (
  <Modal
    title={`Resume · ${name}`}
    open={isOpen}
    onCancel={onClose}
    footer={
      <Button type="primary" onClick={onClose}>
        Close
      </Button>
    }
  >
    <div className={styles.page} aria-hidden="true">
      <span className={`${styles.frost} ${styles.heading}`} />
      <span className={`${styles.frost} ${styles.sub}`} />
      <span className={styles.gap} />
      <span className={`${styles.frost} ${styles.line}`} />
      <span className={`${styles.frost} ${styles.line}`} />
      <span className={`${styles.frost} ${styles.line} ${styles.short}`} />
      <span className={styles.gap} />
      <span className={`${styles.frost} ${styles.sub}`} />
      <span className={`${styles.frost} ${styles.line}`} />
      <span className={`${styles.frost} ${styles.line} ${styles.short}`} />
      <span className={styles.gap} />
      <span className={`${styles.frost} ${styles.sub}`} />
      <span className={`${styles.frost} ${styles.line}`} />
      <span className={`${styles.frost} ${styles.line}`} />
      <span className={`${styles.frost} ${styles.line} ${styles.short}`} />
    </div>
    <Typography.Paragraph type="secondary" className={styles.note}>
      <LockOutlined /> {MASKED_RESUME_NOTE}
    </Typography.Paragraph>
  </Modal>
);

export default MaskedResumeModal;
